import { HttpHeaders } from '@angular/common/http';
import { Component, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppConstants } from '../../../app-constants';
import { ApisService } from '../../../services/apis.service';
import { SharedService } from '../../../services/shared.service';

@Component({
    selector: 'app-multi-select-drop-down',
    imports: [FormsModule, ReactiveFormsModule],
    templateUrl: './multi-select-drop-down.component.html',
    styleUrl: './multi-select-drop-down.component.scss'
})
export class MultiSelectDropDownComponent {

@Input() field: any = {};
  @Input() form!: FormGroup;
  showDropDown = false;
  searchTerm = '';
  dropdownList = []
  filteredDropdownList:any = []; // Initialize with all items
  selectedItems: any[] = [];
  listSelecteditems!: any[];
constructor(private apiService:ApisService,private sharedService:SharedService){}

  ngOnInit() {
    this.form.statusChanges.subscribe(status => {
      console.log(this.form.pristine, 'okkkk')
      if (this.form.pristine) {
        this.searchTerm = ''
      }
    })
    console.log(this.form, 'formmm')
    var headers = new HttpHeaders({ 'is_admin': '0' });
    this.apiService.getApi(AppConstants.apis_end_points.analyze_batch_ids, { headers }).subscribe(data => {
    
      data = this.sharedService.apis_decrypt(data)
      if (this.field.name == 'batchID') {
        this.field.options = []
        this.dropdownList = data.list
        this.filteredDropdownList = [...this.dropdownList];
      } else {
        this.dropdownList = this.field.options
        this.filteredDropdownList = [...this.dropdownList];
      }
    })
  }
  // Toggle dropdown visibility
  toggleDropdown() {
    this.showDropDown = !this.showDropDown;
  }

  // Get placeholder text
  getPlaceholderText() {
    return this.selectedItems.length > 0 ? '' : 'Search or select items';
  }

  // Check if an item is selected
  isSelected(item: any): boolean {
    return this.selectedItems.includes(item);
  }
  ngOnChanges() {
    this.form.valueChanges.subscribe((res:any) => {
      if (res[this.field.name] == null) {
        this.selectedItems = []
      }
    })
       this.form.statusChanges.subscribe(status => {
      console.log(this.form.pristine, 'okkkk')
      if (this.form.pristine) {
        this.searchTerm = ''
      }
    })
  }
  // Select or deselect an item
  selectItem(item: any, fieldName: string) {
    const index = this.selectedItems.indexOf(item);
    if (index === -1) {
      this.selectedItems.push(item);
    } else {
      this.selectedItems.splice(index, 1);
    }
    console.log("fieldName", fieldName, this.form.controls[this.field.name].value)
    if (fieldName == this.field.name) {

      this.searchTerm = ''


      this.form.controls[this.field.name].patchValue(this.selectedItems)
    }
    this.filterDropdown(); // Ensure the list is updated after selection
  }

  // Remove an item from selected items
  removeItem(item: any, fieldName: string) {
    const index = this.selectedItems.indexOf(item);
    if (index !== -1) {
    }
    this.selectedItems.splice(index, 1);
    this.filterDropdown(); // Reapply filter if necessary
  }

  // Filter dropdown list based on search term
  filterDropdown() {
    // this.showDropDown = true
    console.log(this.searchTerm, this.dropdownList)
    this.filteredDropdownList = this.dropdownList.filter((item:any) =>
      item.name.toLowerCase().includes(this.searchTerm.toLowerCase())
    );
  }

}

